import { CompanyBranchData } from "@/features/privateCompanies/types/companyBranches.type";
import { SearchIcon } from "lucide-react";
import { useClientUserBranchAccesses } from "@/features/privateCompanies/hooks/useClientUserBranchAccesses";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import TextField from "@/common/components/TextField";
import Table from "@/common/components/Table";
import { clientUserBranchAccessesTableColumns } from "@/features/privateCompanies/constants/companyBranches/clientUserBranchAccessesTableColumns.constant";
import { Mapper } from "@/common/services/mapper";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ClientUserBranchAccessesTransformer } from "@/features/privateCompanies/services/clientUserBranchAccessesTransformer";
import CompanyBranchUserAccessesCreate from "./CompanyBranchUserAccessesCreate";

interface CompanyBranchUserAccessesProps {
  companyBranch?: CompanyBranchData;
}

const CompanyBranchUserAccesses = ({ companyBranch }: CompanyBranchUserAccessesProps) => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce('');

  const {
    data: clientUserBranchAccesses,
    meta,
    isPending: clientUserBranchAccessesIsPending,
    error: clientUserBranchAccessesError = {} as any,
    refetch: clientUserBranchAccessesRefetch,
  } = useClientUserBranchAccesses({
    filters: {
      branchId: companyBranch?.id,
      search,
      page: Number(filterParams.userBranchAccessesPage) || 1,
    },
    mapper: Mapper.mapWithTransformer({ transformer: ClientUserBranchAccessesTransformer.tableTransformer() }),
  });

  return (
    <ErrorMessageWrapper
      statusCode={clientUserBranchAccessesError?.status}
      refetchFunction={clientUserBranchAccessesRefetch}
      className="h-96"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Busque pelo nome do usuário"
            className="rounded-sm w-full"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, userBranchAccessesSearch: (e.target as HTMLInputElement).value }));
            }}
            value={filterParams.userBranchAccessesSearch}
          />

          <CompanyBranchUserAccessesCreate companyBranch={companyBranch} />
        </div>

        <Table
          className="max-h-[calc(100vh-270px)]"
          columns={clientUserBranchAccessesTableColumns}
          rows={clientUserBranchAccesses}
          totalCount={meta.total}
          totalPages={meta.total_pages}
          isLoadingData={clientUserBranchAccessesIsPending}
          rowEmptyValue="--"
          page={Number(filterParams.userBranchAccessesPage) || 1}
          setPage={(userBranchAccessesPage) => setFilterParams((prev) => ({ ...prev, userBranchAccessesPage }))}
          hasPagination
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default CompanyBranchUserAccesses;
